module.exports = __webpack_public_path__ + "baaf655666341a39bd6b6424fec070bf.png";